<template>
  <div class="home">
    <!-- Header migliorato -->
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top shadow-sm">
      <div class="container-fluid">
        <!-- Logo e titolo -->
        <router-link to="/" class="navbar-brand d-flex align-items-center">
          <img src="../assets/img/datiMaps.png" alt="DATI Maps Logo" class="me-2 logo-img" />
          <div class="logo-text">
            <b class="logo-title">DATIMAPS</b>
            <p class="logo-subtitle mb-0">Geomarketing per popolazione e attività sul territorio.</p>
          </div>
        </router-link>

        <!-- Pulsante per il menu su dispositivi mobili -->
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Menu di navigazione -->
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul v-if="authStore.isLoggedIn" class="navbar-nav ms-auto flex-lg-row flex-column">
            <li class="nav-item">
              <button class="nav-link btn btn-link text-white" @click="toggleModal('ricerca')">
                Ricerca Azienda/Località
              </button>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                :aria-expanded="dropdownOpen.toString()" @click="toggleDropdown">
                Impostazioni
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li>
                  <button class="dropdown-item" @click="toggleModal('salvaFile')">
                    Salva File
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="toggleModal('caricaFile')">
                    Carica Aziende (*.xlsx, *.csv)
                  </button>
                </li>
              </ul>
            </li>
          </ul>
          <ul class="navbar-nav ms-auto flex-lg-row flex-column">
            <!-- Gestione del login -->
            <li class="nav-item ms-auto d-flex">
              <div v-if="authStore.isLoggedIn" class="d-flex flex-column align-items-end text-white">
                <span>Ciao, {{ authStore.user?.name || 'Utente' }}</span>
                <span>{{ authStore.user?.denominazione }}</span>
                <span>
                  Abilitato per:
                  {{ Array.isArray(authStore.user?.provAbilitato) ? authStore.user.provAbilitato.join(", ") :
                    'Tutte le province' }}
                </span>
              </div>
              <div v-if="authStore.isLoggedIn" class="d-flex flex-column align-items-end text-white">
                <button class="btn btn-outline-light mt-2" @click="logout">Logout</button>
              </div>
              <div v-else>
                <button class="btn btn-outline-light" @click="toggleModal('login')">Login</button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Contenitore della mappa -->
    <div class="map-container">
      <div id="map"></div>
    </div>

    <!-- Modale per la ricerca -->
    <ModalRicerca :show="showModal.ricerca" :toggleModal="toggleModal" :comuneAzienda="comuneAzienda"
      :provinciaAzienda="provinciaAzienda" :radiusAzienda="radiusAzienda" :popolazioneMinima="popolazioneMinima"
      @update:comuneAzienda="comuneAzienda = $event" @update:provinciaAzienda="provinciaAzienda = $event"
      @update:radiusAzienda="radiusAzienda = $event" @update:show="showModal.ricerca = $event"
      @update:popolazioneMinima="popolazioneMinima = $event" :errorMessage="errorMessage"
      :cercaAzienda="cercaAzienda" />

    <!-- Modale per la scadenza della sessione -->
    <ModalSessionExpired :show="showModal.sessionExpired" :isLoading="isLoading"
      @update:show="showModal.sessionExpired = $event" @login="handleSessionExpiredLogin" />

    <!-- Modale per il login -->
    <ModalLogin :show="showModal.login" :handleLogin="handleLogin" @update:show="showModal.login = $event"
      :errorMessage="errorMessage" />

    <!-- Slide a scomparsa per LocalitaView.vue -->
    <div class="slide-container" :class="{ 'slide-open': isLocalitaViewOpen }" v-if="authStore.isLoggedIn">
      <LocalitaView :localitaList="localitaList" :selectedLocalita="selectedLocalita" @closeLocalita="closeLocalitaView"
        @select-localita="handleSelectLocalita" />
    </div>

    <!-- Slide a scomparsa per AtecoView.vue -->
    <div class="slide-container" :class="{ 'slide-open': isAtecoViewOpen }" v-if="authStore.isLoggedIn">
      <AtecoView :atecoList="atecoList" :selectedAteco="selectedAteco" :errorMessage="errorMessage"
        @closeAteco="closeAtecoView" @select-ateco="handleSelectAteco" @load-ateco="handleLoadAteco"
        @search-ateco="handleSearchAzienda" @update-error="errorMessage = $event" />
    </div>

    <!-- Slide a scomparsa per AziendeTrovateView.vue -->
    <div class="slide-container" :class="{ 'slide-open': isAziendeAtecoViewOpen }" v-if="authStore.isLoggedIn">
      <AziendeTrovateView :aziendeTrovateList="aziendeTrovateList" @filterAziende="updateMapMarkers"
        @closeAziendeTrovate="closeAziendeAtecoView" />
    </div>

    <!-- Tab per aprire/chiudere la slide -->
    <div class="slide-tab localita-tab" @click="toggleLocalitaView"
      v-if="authStore.isLoggedIn && isSearchAziendaLocalita">
      Località Trovate
    </div>
    <div class="slide-tab ateco-tab" @click="toggleAtecoView" v-if="authStore.isLoggedIn && isSearchAziendaLocalita">
      Ateco Trovati
    </div>
    <div class="slide-tab aziende-cercate-tab" @click="toggleAziendeAtecoView"
      v-if="authStore.isLoggedIn && isSearchAziendaAteco">
      Aziende Cercate
    </div>

    <!-- Loading spinner -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>

    <!-- Input per il caricamento del file -->
    <input type="file" id="fileInput" accept=".xlsx" style="display: none" @change="handleFileUpload" />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import ModalRicerca from "@/components/modali/ModalRicerca.vue";
import ModalLogin from "@/components/modali/ModalLogin.vue";
import ModalSessionExpired from "@/components/modali/ModalSessionExpired.vue";
import LocalitaView from "@/components/LocalitaView.vue";
import AtecoView from "@/components/AtecoView.vue";
import AziendeTrovateView from "@/components/AziendeTrovateView.vue";
import L from "leaflet";
import "@/assets/leaflet/leaflet.css";
import "@/assets/css/homeView.css";
import api from "@/services/api";
import { useAuthStore } from "@/stores/authStore";
import * as XLSX from "xlsx";

const atecoIcons = {
  "1": require("@/assets/leaflet/images/ateco/ateco-arancione.png"),
  "2": require("@/assets/leaflet/images/ateco/ateco-giallo.png"),
  //"3": require("@/assets/leaflet/images/ateco/ateco-grigio.png"),
  //"2": require("@/assets/leaflet/images/ateco/ateco-lilla.png"),
  "3": require("@/assets/leaflet/images/ateco/ateco-rosa.png"),
  "4": require("@/assets/leaflet/images/ateco/ateco-rosso.png"),
  //"7": require("@/assets/leaflet/images/ateco/ateco-verde.png"),
  "5": require("@/assets/leaflet/images/ateco/ateco-viola.png"),
  // Aggiungi altre mappature per i codici ATECO
  "default": require("@/assets/leaflet/images/ateco/ateco-puntoesclamativo.png"),
};

const atecoMarkers = {};

L.Marker.prototype._animateZoom = function (opt) {
  if (!this._map) {
    return;
  }
  const pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
  this._setPos(pos);
};

export default {
  name: "HomeView",
  components: {
    ModalRicerca,
    ModalLogin,
    ModalSessionExpired,
    LocalitaView,
    AtecoView,
    AziendeTrovateView,
  },
  setup() {
    const authStore = useAuthStore();

    // Controlla lo stato di autenticazione al montaggio del componente
    onMounted(() => {
      authStore.checkLoginStatus();
    });

    const map = ref(null);
    const mapReady = ref(false);
    const showModal = ref({ ricerca: false, localitaList: false, atecoList: false, login: false, sessionExpired: false });
    const dropdownOpen = ref(false);

    const comuneAzienda = ref("");
    const provinciaAzienda = ref("");
    const radiusAzienda = ref(10);
    const popolazioneMinima = ref(1000);
    const markerLayerGroup = ref(null); // Layer per i marker
    const errorMessage = ref("");
    const searchRadiusCircle = ref(null);
    const aziendaCoordinates = ref(null); // Variabile per memorizzare le coordinate dell'azienda

    // Slide
    const localitaList = ref([]);
    const selectedLocalita = ref([]);
    const atecoList = ref([]);
    const selectedAteco = ref([]);
    const aziendeTrovateList = ref([]); // Aggiungi la lista delle aziende trovate

    // Tab
    const isLocalitaViewOpen = ref(false);
    const isAtecoViewOpen = ref(false);
    const isAziendeAtecoViewOpen = ref(false);

    // Stato del login
    const isLoggedIn = ref(false);

    // Verifica se è stata fatta la ricerca
    const isSearchAziendaLocalita = ref(false);
    const isSearchAziendaAteco = ref(false);

    const user = ref({ name: "" });

    // Loading
    const isLoading = ref(false);

    const handleLogin = async (loginData) => {
      try {
        isLoading.value = true;
        await authStore.login(loginData);
        showModal.value.login = false;
        isLoggedIn.value = true;
      } catch (error) {
        console.error('Errore durante il login:', authStore.errorMessage);
      } finally {
        isLoading.value = false;
      }
    };

    const logout = () => {
      authStore.logout(clearMap); // Passa il metodo clearMap come callback
      isLoggedIn.value = false; // Aggiorna lo stato di autenticazione
      user.value = { name: "" }; // Resetta i dati dell'utente

      // Chiudi tutte le slide e i tab
      isLocalitaViewOpen.value = false;
      isAtecoViewOpen.value = false;
      isAziendeAtecoViewOpen.value = false;

      // Svuota tutti i dati
      localitaList.value = [];
      selectedLocalita.value = [];
      atecoList.value = [];
      selectedAteco.value = [];
      aziendeTrovateList.value = [];
      isSearchAziendaLocalita.value = false;
      isSearchAziendaAteco.value = false;

      console.log("Logout effettuato e dati resettati");
    };

    const showLocalitaView = () => {
      isLocalitaViewOpen.value = true;
    };

    const closeLocalitaView = () => {
      isLocalitaViewOpen.value = false;
    };

    const closeAtecoView = () => {
      isAtecoViewOpen.value = false;
    };

    const closeAziendeAtecoView = () => {
      isAziendeAtecoViewOpen.value = false;
    };

    const toggleLocalitaView = () => {
      isLocalitaViewOpen.value = !isLocalitaViewOpen.value;
    };

    const toggleAtecoView = () => {
      isAtecoViewOpen.value = !isAtecoViewOpen.value;
    };

    const toggleAziendeAtecoView = () => {
      isAziendeAtecoViewOpen.value = !isAziendeAtecoViewOpen.value;
    };

    // Funzione per gestire la selezione di una località
    const handleSelectLocalita = (localita) => {
      const index = selectedLocalita.value.findIndex(l => l.nome === localita.nome);
      if (index === -1) {
        selectedLocalita.value.push(localita);
      } else {
        selectedLocalita.value.splice(index, 1);
      }

      // Aggiorna l'aspetto del marker
      const marker = markerLayerGroup.value.getLayers().find(layer => {
        const latLng = layer.getLatLng();
        return latLng.lat === localita.lat && latLng.lng === localita.lon;
      });

      if (marker) {
        if (selectedLocalita.value.some(l => l.nome === localita.nome)) {
          marker.setIcon(L.icon({
            iconUrl: require("@/assets/leaflet/images/marker-people-icon-gold.png"),
            iconSize: [21, 21],
          }));
        } else {
          marker.setIcon(L.icon({
            iconUrl: require("@/assets/leaflet/images/marker-people-icon.png"),
            iconSize: [21, 21],
          }));
        }
      }
    };

    const handleSelectAteco = (ateco) => {
      const index = selectedAteco.value.findIndex(a => a.nome === ateco.nome);
      if (index === -1) {
        selectedAteco.value.push(ateco);
      } else {
        selectedAteco.value.splice(index, 1);
      }
    };

    // Funzione per gestire il click su un marker
    const handleMarkerClick = (localita, marker) => {
      handleSelectLocalita(localita);

      if (selectedLocalita.value.some(l => l.nome === localita.nome)) {
        marker.setIcon(L.icon({
          iconUrl: require("@/assets/leaflet/images/marker-people-icon-gold.png"),
          iconSize: [21, 21],
        }));
      } else {
        marker.setIcon(L.icon({
          iconUrl: require("@/assets/leaflet/images/marker-people-icon.png"),
          iconSize: [21, 21],
        }));
      }
    };

    // Carica i marker delle località sulla mappa
    const loadLocalitaMarkers = (localitaList) => {
      // Prima di aggiungere i marker delle località, assicurati che il marker dell'azienda sia presente
      if (aziendaCoordinates.value && !markerLayerGroup.value.getLayers().some(layer =>
        layer.options && layer.options.icon &&
        layer.options.icon.options.iconUrl.includes('marker-icon-green'))) {
        const aziendaMarker = L.marker([aziendaCoordinates.value.lat, aziendaCoordinates.value.lon], {
          icon: L.icon({
            iconUrl: require("@/assets/leaflet/images/marker-icon-green.png"),
            iconSize: [32, 45],
          }),
        }).addTo(markerLayerGroup.value);

        aziendaMarker.bindPopup(
          `<b>${authStore.user?.indirizzo}</b> (${provinciaAzienda.value.toUpperCase()})`
        );
      }

      localitaList.forEach((localita) => {
        if (localita.lat && localita.lon) {
          const isSelected = selectedLocalita.value.some(l => l.nome === localita.nome);
          const localitaMarker = L.marker([localita.lat, localita.lon], {
            icon: L.icon({
              iconUrl: isSelected
                ? require("@/assets/leaflet/images/marker-people-icon-gold.png")
                : require("@/assets/leaflet/images/marker-people-icon.png"),
              iconSize: [21, 21],
            }),
          }).addTo(markerLayerGroup.value);

          localitaMarker.bindPopup(
            `<b>${localita.nome}</b><br>Distanza: ${localita.distanza.toFixed(2)} km<br>Popolazione: ${localita.popolazione}`
          );

          localitaMarker.on("click", () => {
            handleMarkerClick(localita, localitaMarker);
          });
        }
      });
    };

    const clearMap = () => {
      if (markerLayerGroup.value) {
        markerLayerGroup.value.clearLayers();
      }
      if (searchRadiusCircle.value) {
        map.value.removeLayer(searchRadiusCircle.value);
        searchRadiusCircle.value = null;
      }
      localitaList.value = [];
      selectedLocalita.value = [];
      atecoList.value = [];
      selectedAteco.value = [];
      aziendeTrovateList.value = []; // Resetta la lista delle aziende trovate
      isSearchAziendaLocalita.value = false;
      isSearchAziendaAteco.value = false;
    };

    // Funzione per cercare le aziende e caricare i marker
    const cercaAzienda = async () => {
      clearMap();
      if (!mapReady.value || !map.value) {
        console.error("Errore: La mappa non è stata inizializzata correttamente.");
        isSearchAziendaLocalita.value = false;
        isSearchAziendaAteco.value = false;
        return;
      }

      isLoading.value = true;

      markerLayerGroup.value.clearLayers();

      try {
        const response = await api.searchAziendaLocalita(
          comuneAzienda.value,
          provinciaAzienda.value,
          radiusAzienda.value,
          popolazioneMinima.value
        );

        // Verifica che le coordinate siano valide
        if (response?.azienda?.coordinates && response.azienda.coordinates.length === 2) {
          const [lat, lon] = response.azienda.coordinates;

          if (isNaN(lat) || isNaN(lon)) {
            errorMessage.value = "Coordinate non valide: latitudine o longitudine non è un numero.";
          }

          // Salva le coordinate dell'azienda
          aziendaCoordinates.value = { lat, lon };

          map.value.setView([lat, lon], 10);

          addRadiusCircle([lat, lon], radiusAzienda.value);

          const aziendaMarker = L.marker([lat, lon], {
            icon: L.icon({
              iconUrl: require("@/assets/leaflet/images/marker-icon-green.png"),
              iconSize: [32, 45],
            }),
          }).addTo(markerLayerGroup.value);

          aziendaMarker.bindPopup(
            `<b>${authStore.user?.indirizzo}</b> (${provinciaAzienda.value.toUpperCase()})`
          );

          errorMessage.value = "";
          localitaList.value = response.localita || [];
          loadLocalitaMarkers(localitaList.value);
          isSearchAziendaLocalita.value = true;
          showModal.value.ricerca = false;
        } else {
          errorMessage.value = "Le coordinate dell'azienda non sono valide o mancanti.";
        }
      } catch (error) {
        errorMessage.value = error.message || "Errore durante la ricerca delle località.";
      } finally {
        isLoading.value = false;
      }
    };

    const addRadiusCircle = (center, radiusKm) => {
      if (searchRadiusCircle.value) {
        map.value.removeLayer(searchRadiusCircle.value);
      }
      searchRadiusCircle.value = L.circle(center, {
        color: 'blue',
        weight: 2,
        opacity: 0.5,
        fillColor: 'blue',
        fillOpacity: 0.1,
        radius: radiusKm * 1000
      }).addTo(map.value);
    };

    // Funzione per caricare gli ATECO
    const handleLoadAteco = async () => {
      try {
        isLoading.value = true;
        errorMessage.value = ""; // Resetta il messaggio di errore

        if (!authStore.token) {
          errorMessage.value = "Token non trovato. Effettua nuovamente il login.";
        }

        const atecoListData = await api.loadAtecoList(authStore);

        if (atecoListData && atecoListData.length > 0) {
          atecoList.value = atecoListData;
        } else {
          console.warn("Nessun dato ATECO trovato.");
          atecoList.value = [];
        }
      } catch (error) {
        console.error("Errore durante il caricamento degli ATECO:", error.message);
        errorMessage.value = error.message || "Errore durante il caricamento degli ATECO.";
        atecoList.value = [];
      } finally {
        isLoading.value = false;
      }
    };

    // Funzione per cercare 
    const handleSearchAzienda = async (selectedAtecoCodes) => {
      isLoading.value = true;

      try {
        const response = await api.searchAzienda(authStore, selectedAtecoCodes, provinciaAzienda.value.toUpperCase());

        if (response && response.length > 0) {
          // Rimuovi i marker ATECO precedenti
          markerLayerGroup.value.eachLayer((layer) => {
            if (layer.options && layer.options.isAtecoMarker) {
              markerLayerGroup.value.removeLayer(layer);
            }
          });

          // Filtra i risultati ATECO in base al raggio
          const aziendaCoordinates = searchRadiusCircle.value.getLatLng(); // Centro del raggio
          const radiusMeters = searchRadiusCircle.value.getRadius(); // Raggio in metri

          const filteredAteco = response.filter((ateco) => {
            if (ateco.LATITUDINE && ateco.LONGITUDINE) {
              const distance = map.value.distance(
                [aziendaCoordinates.lat, aziendaCoordinates.lng],
                [ateco.LATITUDINE, ateco.LONGITUDINE]
              );
              return distance <= radiusMeters; // Mantieni solo quelli nel raggio
            }
            return false;
          });

          // Aggiungi i nuovi marker per i risultati ATECO filtrati
          const uniqueAtecoCodes = [...new Set(filteredAteco.map(ateco => ateco.CODICE))];

          let keyMarker = 1;
          uniqueAtecoCodes.forEach((code) => {
            if (keyMarker > 8) {
              atecoMarkers[code] = "default";
            } else {
              atecoMarkers[code] = keyMarker; // Associa il codice ATECO al keyMarker
            }

            keyMarker++;
          });

          filteredAteco.forEach((ateco) => {
            const icona = atecoIcons[atecoMarkers[ateco.CODICE]] || atecoIcons.default;
            const iconSize = icona === atecoIcons.default ? [15, 15] : [30, 30]; // Imposta la dimensione in base all'icona

            const atecoMarker = L.marker([ateco.LATITUDINE, ateco.LONGITUDINE], {
              icon: L.icon({
                iconUrl: icona,
                iconSize: iconSize,
              }),
              isAtecoMarker: true, // Identifica questo marker come marker di un'azienda
            }).addTo(markerLayerGroup.value);

            atecoMarker.bindPopup(`
              <b>${ateco.DNZ}</b><br>
              <b>Codice ATECO:</b> ${ateco.CODICE}<br>
              <b>Categoria:</b> ${ateco.CATEGORIA}<br>
              <b>Indirizzo:</b> ${ateco.VIA} ${ateco.VIA_DENOMINAZIONE} ${ateco.NUMERO_CIVICO}, ${ateco.COMUNE} (${ateco.PRV})<br>
              <b>Partita IVA:</b> ${ateco.PARTITA_IVA}<br>
              <b>Email:</b> ${ateco.EMAIL}
            `);
          });

          // Aggiorna la lista delle aziende trovate
          aziendeTrovateList.value = filteredAteco;
          isSearchAziendaAteco.value = true; // Apri la slide
          closeAtecoView();
          toggleAziendeAtecoView();
        }
      } catch (error) {
        errorMessage.value = error.message.replace(/^Error:\s*/, "") || "Errore durante la ricerca degli ATECO.";
      } finally {
        isLoading.value = false;
      }
    };

    // Rileva l'attività dell'utente
    const resetInactivityTimer = () => {
      if (authStore.isLoggedIn) {
        authStore.resetInactivityTimer();
      }
    };

    const salvaFile = async () => {
      try {
        console.log("Salvataggio del file in corso...");

        // Prepara i dati da esportare
        const aziendaData = [
          {
            nome: authStore.user?.denominazione,
            indirizzo: authStore.user?.indirizzo,
            comune: comuneAzienda.value,
            provincia: provinciaAzienda.value,
            raggio: radiusAzienda.value,
            popolazioneMinima: popolazioneMinima.value,
            latitudine: aziendaCoordinates.value?.lat || "Non disponibile",
            longitudine: aziendaCoordinates.value?.lon || "Non disponibile",
          },
        ];

        const localitaData = localitaList.value.map((localita) => ({
          nome: localita.nome,
          latitudine: localita.lat,
          longitudine: localita.lon,
          distanza: localita.distanza,
          popolazione: localita.popolazione,
        }));

        const localitaSelezionateData = selectedLocalita.value.map((localita) => ({
          nome: localita.nome,
          latitudine: localita.lat,
          longitudine: localita.lon,
          distanza: localita.distanza,
          popolazione: localita.popolazione,
        }));

        const aziendeTrovateData = aziendeTrovateList.value.map((azienda) => ({
          nome: azienda.DNZ,
          codice: azienda.CODICE,
          categoria: azienda.CATEGORIA,
          //indirizzo: `${azienda.VIA} ${azienda.VIA_DENOMINAZIONE} ${azienda.NUMERO_CIVICO}, ${azienda.COMUNE} (${azienda.PRV})`,
          via: azienda.VIA,
          via_denominazione: azienda.VIA_DENOMINAZIONE,
          numero_civico: azienda.NUMERO_CIVICO,
          prv: azienda.PRV,
          comune: azienda.COMUNE,
          partitaIva: azienda.PARTITA_IVA,
          email: azienda.EMAIL,
          telefono: azienda.TELEFONO,
          codiceFiscale: azienda.CODICE_FISCALE,
          latitudine: azienda.LATITUDINE,
          longitudine: azienda.LONGITUDINE,
        }));

        // Genera il file Excel
        const excelBuffer = await api.generateExcel(aziendaData, localitaData, localitaSelezionateData, aziendeTrovateData);

        // Crea un blob per il download
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = aziendaData[0].nome + "_DATIMAPS.xlsx"; // Nome del file

        link.click();

        console.log("File salvato con successo.");
      } catch (error) {
        console.error("Errore durante il salvataggio del file:", error);
      }
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (!file) {
        console.error("Nessun file selezionato.");
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Leggi i fogli di lavoro
        const aziendaSheet = XLSX.utils.sheet_to_json(workbook.Sheets["Dati Azienda"] || {});
        const localitaSheet = XLSX.utils.sheet_to_json(workbook.Sheets["Località Trovate"] || {});
        const localitaSelezionateSheet = XLSX.utils.sheet_to_json(workbook.Sheets["Località Selezionate"] || {});
        const aziendeTrovateSheet = XLSX.utils.sheet_to_json(workbook.Sheets["Aziende Cercate"] || {});

        // Aggiorna i dati nel componente
        if (aziendaSheet.length > 0) {
          comuneAzienda.value = aziendaSheet[0].comune || "";
          provinciaAzienda.value = aziendaSheet[0].provincia || "";
          radiusAzienda.value = aziendaSheet[0].raggio || 10;
          popolazioneMinima.value = aziendaSheet[0].popolazioneMinima || 1000;
          aziendaCoordinates.value = {
            lat: aziendaSheet[0].latitudine || null,
            lon: aziendaSheet[0].longitudine || null,
          };

          // Aggiungi il marker dell'azienda
          if (aziendaCoordinates.value.lat && aziendaCoordinates.value.lon) {
            const aziendaMarker = L.marker([aziendaCoordinates.value.lat, aziendaCoordinates.value.lon], {
              icon: L.icon({
                iconUrl: require("@/assets/leaflet/images/marker-icon-green.png"),
                iconSize: [32, 45],
              }),
            }).addTo(markerLayerGroup.value);

            aziendaMarker.bindPopup(
              `<b>${aziendaSheet[0].nome || "Azienda"}</b><br>${aziendaSheet[0].indirizzo || "Indirizzo non disponibile"}`
            );

            map.value.setView([aziendaCoordinates.value.lat, aziendaCoordinates.value.lon], 10);
            addRadiusCircle([aziendaCoordinates.value.lat, aziendaCoordinates.value.lon], radiusAzienda.value);
          }
        }

        // Aggiungi i marker delle località
        localitaList.value = localitaSheet.map((localita) => ({
          nome: localita.nome,
          lat: localita.latitudine,
          lon: localita.longitudine,
          distanza: localita.distanza,
          popolazione: localita.popolazione,
        }));

        loadLocalitaMarkers(localitaList.value);

        // Aggiorna le località selezionate
        selectedLocalita.value = localitaSelezionateSheet.map((localita) => ({
          nome: localita.nome,
          lat: localita.latitudine,
          lon: localita.longitudine,
          distanza: localita.distanza,
          popolazione: localita.popolazione,
        }));

        // Aggiungi i marker delle località selezionate
        selectedLocalita.value.forEach((localita) => {
          const marker = L.marker([localita.lat, localita.lon], {
            icon: L.icon({
              iconUrl: require("@/assets/leaflet/images/marker-people-icon-gold.png"),
              iconSize: [21, 21],
            }),
          }).addTo(markerLayerGroup.value);

          marker.bindPopup(
            `<b>${localita.nome}</b><br>Distanza: ${localita.distanza.toFixed(2)} km<br>Popolazione: ${localita.popolazione}`
          );
        });

        // Aggiungi i marker delle aziende trovate
        aziendeTrovateList.value = aziendeTrovateSheet.map((azienda) => ({
          DNZ: azienda.nome,
          CODICE: azienda.codice,
          CATEGORIA: azienda.categoria,
          VIA: azienda.via,
          VIA_DENOMINAZIONE: azienda.via_denominazione,
          PRV: azienda.prv,
          NUMERO_CIVICO: azienda.numero_civico,
          COMUNE: azienda.comune,
          PARTITA_IVA: azienda.partitaIva,
          EMAIL: azienda.email,
          LATITUDINE: azienda.latitudine,
          LONGITUDINE: azienda.longitudine,
          TELEFONO: azienda.telefono,
          CODICE_FISCALE: azienda.codiceFiscale,
        }));

        let uniqueAtecoCodes = [...new Set(aziendeTrovateList.value.map(azienda => azienda.CODICE))];
        let keyMarker = 1;
        uniqueAtecoCodes.forEach((code) => {
          if (keyMarker > 8) {
            atecoMarkers[code] = "default";
          } else {
            atecoMarkers[code] = keyMarker; // Associa il codice ATECO al keyMarker
          }

          keyMarker++;
        });

        aziendeTrovateList.value.forEach((azienda) => {
          if (azienda.LATITUDINE && azienda.LONGITUDINE) {
            const icona = atecoIcons[atecoMarkers[azienda.CODICE]] || atecoIcons.default;
            const iconSize = icona === atecoIcons.default ? [15, 15] : [30, 30]; // Dimensione in base all'icona

            const aziendaMarker = L.marker([azienda.LATITUDINE, azienda.LONGITUDINE], {
              icon: L.icon({
                iconUrl: icona,
                iconSize: iconSize,
              }),
              isAtecoMarker: true,
            }).addTo(markerLayerGroup.value);

            aziendaMarker.bindPopup(
              `<b>${azienda.DENOMINAZIONE}</b><br>
              <b>Codice ATECO:</b> ${azienda.CODICE}<br>
              <b>Categoria:</b> ${azienda.CATEGORIA}<br>
              <b>Indirizzo:</b> ${azienda.VIA} ${azienda.VIA_DENOMINAZIONE} ${azienda.NUMERO_CIVICO}, ${azienda.COMUNE} (${azienda.PRV}))<br>
              <b>Partita IVA:</b> ${azienda.PARTITA_IVA}<br>
              <b>Email:</b> ${azienda.EMAIL || "Non disponibile"}`
            );
          }
        });

        // Visualizza i tab e popola i dati
        isSearchAziendaLocalita.value = localitaList.value.length > 0;
        isSearchAziendaAteco.value = aziendeTrovateList.value.length > 0;

        console.log("File caricato con successo.");
      };

      reader.onerror = (error) => {
        console.error("Errore durante il caricamento del file:", error);
      };

      reader.readAsArrayBuffer(file);
    };

    onMounted(() => {
      authStore.checkLoginStatus(); // Recupera il token e lo stato di autenticazione

      const mapElement = document.getElementById("map");
      if (!mapElement) {
        console.error("Elemento mappa non trovato.");
        return;
      }

      map.value = L.map(mapElement, {
        zoomControl: true, zoom: 10, minZoom: 2, maxZoom: 18,
        zoomAnimation: false, fadeAnimation: true, markerZoomAnimation: true
      }).setView([41.9028, 12.4964], 10);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap contributors",
        crossOrigin: true,
        interactive: true,
      }).addTo(map.value);

      markerLayerGroup.value = L.layerGroup().addTo(map.value);
      mapReady.value = true;

      if (authStore.isLoggedIn) {
        const sessionCheckInterval = setInterval(() => {
          authStore.checkLoginStatus();

          if (!authStore.isLoggedIn) {
            clearInterval(sessionCheckInterval); // Ferma il controllo se l'utente è disconnesso
            showModal.value.sessionExpired = true; // Mostra la modale di sessione scaduta
            isLoggedIn.value = false; // Aggiorna lo stato di autenticazione
          } else {
            // Resetta il timer di inattività se l'utente è ancora loggato
            authStore.resetInactivityTimer();
          }
        }, 300 * 1000); // Controlla ogni 5 minuti
      }


      // Aggiungi event listener per l'attività dell'utente
      window.addEventListener('mousemove', resetInactivityTimer);
      window.addEventListener('keydown', resetInactivityTimer);
      window.addEventListener('click', resetInactivityTimer);

      // Controlla lo stato di login all'avvio
      authStore.checkLoginStatus();
    });

    const toggleDropdown = () => {
      dropdownOpen.value = !dropdownOpen.value;
    };

    const toggleModal = (modalName) => {
      if (modalName === "login") {
        errorMessage.value = "";
      } else if (modalName === "ricerca") {
        errorMessage.value = "";
      } else if (modalName === "salvaFile") {
        salvaFile();
      } else if (modalName === "caricaFile") {
        document.getElementById("fileInput").click(); // Simula il click sull'input file
      }
      showModal.value[modalName] = !showModal.value[modalName];
    };

    const handleSessionExpiredLogin = () => {
      showModal.value.sessionExpired = false; // Chiudi la modale di sessione scaduta
      showModal.value.login = true; // Apri la modale di login
    };

    const updateMapMarkers = (filteredAziende) => {
      if (!markerLayerGroup.value) {
        console.error("Layer dei marker non inizializzato.");
        return;
      }

      // Rimuovi solo i marker delle aziende (identificati da `isAtecoMarker`)
      markerLayerGroup.value.eachLayer((layer) => {
        if (layer.options && layer.options.isAtecoMarker) {
          markerLayerGroup.value.removeLayer(layer);
        }
      });

      // Aggiungi i nuovi marker per le aziende filtrate
      filteredAziende.forEach((azienda) => {
        if (azienda.LATITUDINE && azienda.LONGITUDINE) {
          // Recupera l'icona corrispondente al codice ATECO o usa quella di default
          const icona = atecoIcons[atecoMarkers[azienda.CODICE]] || atecoIcons.default;
          const iconSize = icona === atecoIcons.default ? [15, 15] : [30, 30]; // Dimensione in base all'icona

          const aziendaMarker = L.marker([azienda.LATITUDINE, azienda.LONGITUDINE], {
            icon: L.icon({
              iconUrl: icona,
              iconSize: iconSize,
            }),
            isAtecoMarker: true, // Identifica questo marker come marker di un'azienda
          });

          // Aggiungi un popup con i dettagli dell'azienda
          aziendaMarker.bindPopup(`
            <b>${azienda.DENOMINAZIONE}</b><br>
            <b>Codice ATECO:</b> ${azienda.CODICE}<br>
            <b>Categoria:</b> ${azienda.CATEGORIA}<br>
            <b>Indirizzo:</b> ${azienda.VIA} ${azienda.NUMERO_CIVICO}, ${azienda.COMUNE} (${azienda.PRV})<br>
            <b>Partita IVA:</b> ${azienda.PARTITA_IVA}<br>
            <b>Email:</b> ${azienda.EMAIL || "Non disponibile"}
          `);

          // Aggiungi il marker al layer
          aziendaMarker.addTo(markerLayerGroup.value);
        } else {
          console.warn(`Azienda con dati incompleti: ${azienda.DENOMINAZIONE}`);
        }
      });
    };

    onUnmounted(() => {
      // Rimuovi gli event listener quando il componente viene smontato
      window.removeEventListener('mousemove', resetInactivityTimer);
      window.removeEventListener('keydown', resetInactivityTimer);
      window.removeEventListener('click', resetInactivityTimer);
    });

    return {
      map,
      showModal,
      localitaList,
      comuneAzienda,
      provinciaAzienda,
      radiusAzienda,
      popolazioneMinima,
      markerLayerGroup,
      mapReady,
      dropdownOpen,
      toggleModal,
      toggleDropdown,
      cercaAzienda,
      isLoggedIn,
      user,
      handleLogin,
      logout,
      errorMessage,
      searchRadiusCircle,
      isLocalitaViewOpen,
      isAtecoViewOpen,
      selectedLocalita,
      showLocalitaView,
      closeLocalitaView,
      closeAtecoView,
      closeAziendeAtecoView,
      toggleLocalitaView,
      toggleAtecoView,
      toggleAziendeAtecoView,
      handleSelectLocalita,
      handleSelectAteco,
      isSearchAziendaLocalita,
      isSearchAziendaAteco,
      isAziendeAtecoViewOpen,
      atecoList,
      selectedAteco,
      aziendeTrovateList, // Esponi la lista delle aziende trovate
      isLoading,
      handleLoadAteco,
      handleSearchAzienda,
      authStore,
      handleSessionExpiredLogin,
      updateMapMarkers,
      salvaFile,
      handleFileUpload,
    };
  },
};
</script>

<style scoped>
.d-flex.flex-column {
  margin-right: 0.5rem;
}

.d-flex {
  display: flex;
}
</style>